import React, { useState } from "react";
import { Card } from "primereact/card";
import DatabaseDialog from "./DatabaseDialog";

const DatabaseCard = ({ database }) => {
  const [dialogVisible, setDialogVisible] = useState(false);

  const openDialog = () => {
    setDialogVisible(true);
  };

  const closeDialog = () => {
    setDialogVisible(false);
  };

  return (
    <div className="database-card-wrapper">
      <Card className="custom-card p-card-hover" onClick={openDialog}>
        <div className="card-content">
          <img
            src="/img/database_icon.png"
            alt={`Icon for ${database.databaseName}`}
            className="card-logo"
            style={{ width: "70px", height: "70px" }}
          />
          <h3 className="card-status-title">{database.databaseName}</h3>
        </div>
      </Card>
      <DatabaseDialog
        visible={dialogVisible}
        onHide={closeDialog}
        database={database}
      />
    </div>
  );
};

export default DatabaseCard;
